import { Card, Container } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import ReportComponent from "../core/ReportComponent"
import { parsedUser } from "../common/GetCurrentUser"

const ReportDemoPage = () => {
    const { t } = useTranslation("global")
    const user = parsedUser()

    if (!user?.OrganizationId) {
        return (
            <Container fluid>
                <Card className="my-4">
                    <Card.Body>{t("Organization not selected")}</Card.Body>
                </Card>
            </Container>
        )
    }

    return (
        <ReportComponent
            title={t("New Places")}
            fileName="new-places-report"
            endpoint={`reports/newPlaces?OrganizationId=${user.OrganizationId}`}
            // groupBy="city"
            columns={[
                {
                    key: "created",
                    type: "date",
                    label: t("Created Date"),
                    sortable: true,
                },
                {
                    key: "placeName",
                    label: t("Place"),
                    sortable: true,
                },
                {
                    key: "assignedTo",
                    label: t("Agent"),
                    sortable: true,
                },

            ]}
            filterFields={[
                { name: "startDate", title: t("Start Date"), htmlType: "date", dbType: "date", containerClass: "col-md-4" },
                { name: "endDate", title: t("End Date"), htmlType: "date", dbType: "date", containerClass: "col-md-4" },
            ]}
        />
    )
}

export default ReportDemoPage
